
import { prizeData } from './prizedata'
import '../../assets/Css/prizeSection.css'
const PrizeSection = () => {
    return (
        <>
            <div className="row mt-5 bigcontainer" style={{flexWrap:'wrap',paddingBottom:'20px' }}>
                <div className="col-md-10 content m-auto text-center">
                    <p className="winbig"><button>WIN BIG</button> </p>
                    <p className='taketest'>Take the Test ,Top the Charts,and <span className="glory"> Grab the glory!</span></p>
                </div>
            </div>
            <div className="row justify-content-center gap-4 mt-5 prizecontainers" style={{padding:'0px 15px'}}>
                {prizeData.map((item) => (
                    <div key={item.id} className="col-xl-3 col-md-6 col-sm-10 bg-light text-center p-4 rounded shadow-sm">
                        <img
                            src={item.imageurl}
                            alt={item.name}
                            className="img-fluid mb-3"
                            style={{ height: '180px', objectFit: 'contain' }}
                        />
                        <p className="pricenumber">{item.priceNumber} Prize</p>
                        <p className="prizeName mb-0">{item.name}</p>
                    </div>
                ))}
            </div>

        </>
    )
}

export default PrizeSection